import { c as _c } from "react/compiler-runtime";
import { IcoArrowRightSmall16 } from '@onefootprint/icons';
import type { ApiNodeData, ApiNodeDataConditional } from '@onefootprint/request-types/dashboard';
import { Dropdown, useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useStore from '../../hooks/use-store';
type CopyAsRulesItemProps = {
  data: ApiNodeData;
  onClick: () => void;
};
const isConditionalNode = (data: ApiNodeData): data is ApiNodeDataConditional => {
  return data.kind === 'conditional';
};
const generateNodeId = () => `dn_${Math.random().toString(36).substring(2)}${Date.now().toString(36)}`;
const convertConditionalToRulesNode = (node: ApiNodeDataConditional) => ({
  id: generateNodeId(),
  kind: 'rules' as const,
  name: node.name ?? 'Converted Rules',
  key: '',
  defaultValue: node.defaultBranch.name,
  groups: node.conditionalBranches.map(branch => ({
    value: branch.branch.name,
    conditions: branch.rules.map(rule => ({
      id: rule.ruleId,
      expression: rule.ruleExpression
    }))
  }))
});
const CopyAsRulesItem = t0 => {
  const $ = _c(12);
  const {
    data,
    onClick
  } = t0;
  const {
    toast
  } = useToast();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "edit.copyAsRulesNode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    data: t2
  } = useStore();
  const {
    graph
  } = t2;
  if (!isConditionalNode(data)) {
    return null;
  }
  let t3;
  if ($[1] !== data || $[2] !== graph.subject || $[3] !== onClick || $[4] !== t || $[5] !== toast) {
    t3 = () => {
      onClick();
      const rulesNode = {
        ...convertConditionalToRulesNode(data),
        subject: graph.subject
      };
      navigator.clipboard.writeText(JSON.stringify([rulesNode], null, 2));
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
    };
    $[1] = data;
    $[2] = graph.subject;
    $[3] = onClick;
    $[4] = t;
    $[5] = toast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCopy = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp3);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleCopy || $[10] !== t4) {
    t5 = <Dropdown.Item iconLeft={IcoArrowRightSmall16} onSelect={handleCopy}>{t4}</Dropdown.Item>;
    $[9] = handleCopy;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default CopyAsRulesItem;
function _temp($) {
  return $.toast.title;
}
function _temp2($_0) {
  return $_0.toast.description;
}
function _temp3($_1) {
  return $_1.label;
}